import { RailyticsWC } from './railytics-wc'

type Railytics = Rai["RailyticsInstance"];

async function existsRailytics() {
  return new Promise<Railytics>((resolve) => {
    if (window.Rai?.RailyticsInstance) {
      return resolve(window.Rai.RailyticsInstance)
    }
    window.Rai = new Proxy(window.Rai ?? {} as Rai, {
      set: (target, p, newValue, receiver) => {
        const setted = Reflect.set(target, p, newValue, receiver)
        if (p === 'RailyticsInstance') {
          // clearTimeout(timeoutId)
          setTimeout(() => {
            resolve(window.Rai!.RailyticsInstance)
          })
        }
        return setted
      }
    })
    // const timeoutId = window.setTimeout(() => {
    //   reject(new Error('Timeout di RailyticsInstance'))
    // }, 10e3)
  })
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/* @ts-ignore */
import(/* @vite-ignore */__public_path__ + '/common/assets/js/webcomponents/railytics.js').then(async () => {
  await existsRailytics()
  customElements.define('rai-railytics', RailyticsWC)
}).catch(console.error);
